import * as React from 'react';
import { useSelector } from 'react-redux';

import { Disclaimer } from '../../components/Disclaimer/Disclaimer';
import {
  isShowAuctionDisclaimer,
  isShowBankDisclaimer,
  isShowDemolishedProgramDisclaimer,
  isShowElectronicTradeDisclaimer,
  isShowEncumbranceDisclaimer,
} from '../../selectors';

export const DisclaimerContainer: React.FC = () => {
  const showAuctionDisclaimer = useSelector(isShowAuctionDisclaimer);
  const showBankDisclaimer = useSelector(isShowBankDisclaimer);
  const showDemolishedProgramDisclaimer = useSelector(isShowDemolishedProgramDisclaimer);
  const showElectronicTradeDisclaimer = useSelector(isShowElectronicTradeDisclaimer);
  const showEncumbranceDisclaimer = useSelector(isShowEncumbranceDisclaimer);

  return (
    <>
      {showAuctionDisclaimer && (
        <Disclaimer
          testId="auction"
          header="Реализуется через аукцион"
          title="Объект продается на открытом аукционе и&nbsp;переходит к тому, кто предложит самую высокую цену"
        />
      )}

      {showBankDisclaimer && (
        <Disclaimer
          testId="bank"
          header="Залоговая недвижимость"
          title="Объект продаётся банком, которому не&nbsp;вернул кредит заёмщик — бывший собственник"
        />
      )}

      {showDemolishedProgramDisclaimer && (
        <Disclaimer
          testId="demolished"
          header="Дом под снос"
          title="По результатам голосования жильцов дом включен в программу реновации и будет снесен"
        />
      )}

      {showElectronicTradeDisclaimer && (
        <Disclaimer
          testId="electronic-trade"
          header="Реализуется через аукцион"
          title="Объект продается на открытом аукционе и&nbsp;переходит к тому, кто предложит самую высокую цену"
        />
      )}

      {showEncumbranceDisclaimer && (
        <Disclaimer
          testId="encumbrance"
          header="От банка, с обременением"
          title="Объект с обременением, подробности уточняйте по телефону"
        />
      )}
    </>
  );
};
